/**
 * @Author: 左建
 * @Date: 2022/6/27 11:28
 * @LastEditTime: 2022/6/27 11:28
 * @Description: 问卷先关路由相关配置
 *
*/
import { manageRoutes, sidebarRoutes } from "./manage"

export default {
    sidebarRoutes,
    manageRoutes
}
